import axios, { AxiosRequestConfig, Method, ResponseType } from "axios";
import { APIRequestOptions, QueryParams, Token } from "../../types/api";
import { ErrorCodesRedirections } from "../Functions";
import {
  DefaultRequestTimeOut,
  EnglishCode,
} from "../constants/CommonConstants";

const Api = async <TRequest, TResponse>({
  method,
  endpoint,
  headers = {},
  body,
  filter,
  signal,
  token,
  responseType = "json",
  contentType,
  navigateToErrorPageIfThereisError,
}: APIRequestOptions<TRequest, TResponse> & {
  token?: Token;
  navigateToErrorPageIfThereisError?: boolean;
}): Promise<TResponse> => {
  function toQueryString(filterVal: QueryParams[]): string {
    if (filterVal.length === 0) return "";
    const queryStrings = filterVal.map((obj) =>
      Object.keys(obj)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(String(obj[key]))}`,
        )
        .join("&"),
    );
    return `?${queryStrings.join("&")}`;
  }

  const queryString = filter ? toQueryString(filter) : "";
  const lang = localStorage.getItem("i18nextLng") || EnglishCode;

  const config: AxiosRequestConfig = {
    url: queryString !== "" ? `${endpoint}${queryString}` : `${endpoint}`,
    method: method as Method,
    headers: {
      "Accept-Language": lang,
      Authorization: token ? `${token}` : "",
      ...headers,
      ...(body instanceof FormData
        ? {}
        : { "Content-Type": contentType ? contentType : "application/json" }),
    },
    data: method !== "GET" ? body : null,
    signal,
    responseType: responseType as ResponseType,
    timeout: DefaultRequestTimeOut,
  };

  try {
    const response = await axios(config);
    if (response.data.Code) {
      ErrorCodesRedirections(
        response.data.Code,
        navigateToErrorPageIfThereisError ?? true,
      );
    }
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        ErrorCodesRedirections(
          error?.response?.status,
          navigateToErrorPageIfThereisError ?? true,
        );
      }
      //?=================Status Codes================================
      if (error.response) {
        throw new Error(
          `Error: ${error.response.status} - ${error.response.data}`,
        );
      } else if (error.request) {
        throw new Error("Error: No response received");
      } else {
        throw new Error(error.message);
      }
    } else {
      console.error("Unexpected Error: ", error);
      throw new Error("Unexpected error occurred");
    }
  }
};

export default Api;
